export default __webpack_public_path__ + "12067e0de552048b9a57c42594acc279.svg";